export default [
    {
        "id": 1,
        "name": "Afghanistan",
        "native": "افغانستان",
        "dial_code": "+93",
        "iso2": "AF",
        "mask": "+93-##-###-####",
        "emoji": "🇦🇫",
        "translations": {
            "es": "Afganistán",
            "en": "Afghanistan",
            "pt": "Afeganistão"
        }
    },
    {
        "id": 2,
        "name": "Aland Islands",
        "native": "Åland",
        "dial_code": "+358",
        "iso2": "AX",
        "emoji": "🇦🇽",
        "translations": {
            "es": "Alandia",
            "en": "Aland Islands",
            "pt": "Ilhas de Aland"
        }
    },
    {
        "id": 3,
        "name": "Albania",
        "native": "Shqipëria",
        "dial_code": "+355",
        "iso2": "AL",
        "mask": "+355(###)###-###",
        "emoji": "🇦🇱",
        "translations": {
            "es": "Albania",
            "en": "Albania",
            "pt": "Albânia"
        }
    },
    {
        "id": 4,
        "name": "Algeria",
        "native": "الجزائر",
        "dial_code": "+213",
        "iso2": "DZ",
        "mask": "+213-##-###-####",
        "emoji": "🇩🇿",
        "translations": {
            "es": "Argelia",
            "en": "Algeria",
            "pt": "Argélia"
        }
    },
    {
        "id": 5,
        "name": "American Samoa",
        "native": "American Samoa",
        "dial_code": "+1684",
        "iso2": "AS",
        "mask": "+1(684)###-####",
        "emoji": "🇦🇸",
        "translations": {
            "es": "Samoa Americana",
            "en": "American Samoa",
            "pt": "Samoa Americana"
        }
    },
    {
        "id": 6,
        "name": "Andorra",
        "native": "Andorra",
        "dial_code": "+376",
        "iso2": "AD",
        "mask": "+376-###-###",
        "emoji": "🇦🇩",
        "translations": {
            "es": "Andorra",
            "en": "Andorra",
            "pt": "Andorra"
        }
    },
    {
        "id": 7,
        "name": "Angola",
        "native": "Angola",
        "dial_code": "+244",
        "iso2": "AO",
        "mask": "+244(###)###-###",
        "emoji": "🇦🇴",
        "translations": {
            "es": "Angola",
            "en": "Angola",
            "pt": "Angola"
        }
    },
    {
        "id": 8,
        "name": "Anguilla",
        "native": "Anguilla",
        "dial_code": "+1264",
        "iso2": "AI",
        "mask": "+1(264)###-####",
        "emoji": "🇦🇮",
        "translations": {
            "es": "Anguilla",
            "en": "Anguilla",
            "pt": "Anguila"
        }
    },
    {
        "id": 9,
        "name": "Antarctica",
        "native": "Antarctica",
        "dial_code": "+672",
        "iso2": "AQ",
        "mask": "+672-1##-###",
        "emoji": "🇦🇶",
        "translations": {
            "es": "Antártida",
            "en": "Antarctica",
            "pt": "Antártida"
        }
    },
    {
        "id": 10,
        "name": "Antigua And Barbuda",
        "native": "Antigua and Barbuda",
        "dial_code": "+1268",
        "iso2": "AG",
        "mask": "+1(268)###-####",
        "emoji": "🇦🇬",
        "translations": {
            "es": "Antigua y Barbuda",
            "en": "Antigua And Barbuda",
            "pt": "Antígua e Barbuda"
        }
    },
    {
        "id": 11,
        "name": "Argentina",
        "native": "Argentina",
        "dial_code": "+54",
        "iso2": "AR",
        "mask": "+54 (###) ###-####",
        "masks": {
            "cpf": "##.###.###",
            "phone": "+54 (###) ###-####",
            "address.zip": "A#### AAA",
            "vehicle.plate": "AAA-###",
        },
        "states": [
            "Buenos Aires",
        ],
        "cities": [
            "Buenos Aires",
        ],
        "emoji": "🇦🇷",
        "translations": {
            "es": "Argentina",
            "en": "Argentina",
            "pt": "Argentina"
        }
    },
    {
        "id": 12,
        "name": "Armenia",
        "native": "Հայաստան",
        "dial_code": "+374",
        "iso2": "AM",
        "mask": "+374-##-###-###",
        "emoji": "🇦🇲",
        "translations": {
            "es": "Armenia",
            "en": "Armenia",
            "pt": "Armênia"
        }
    },
    {
        "id": 13,
        "name": "Aruba",
        "native": "Aruba",
        "dial_code": "+297",
        "iso2": "AW",
        "mask": "+297-###-####",
        "emoji": "🇦🇼",
        "translations": {
            "es": "Aruba",
            "en": "Aruba",
            "pt": "Aruba"
        }
    },
    {
        "id": 14,
        "name": "Australia",
        "native": "Australia",
        "dial_code": "+61",
        "iso2": "AU",
        "mask": "+61-#-####-####",
        "emoji": "🇦🇺",
        "translations": {
            "es": "Australia",
            "en": "Australia",
            "pt": "Austrália"
        }
    },
    {
        "id": 15,
        "name": "Austria",
        "native": "Österreich",
        "dial_code": "+43",
        "iso2": "AT",
        "mask": "+43(###)###-####",
        "emoji": "🇦🇹",
        "translations": {
            "es": "Austria",
            "en": "Austria",
            "pt": "áustria"
        }
    },
    {
        "id": 16,
        "name": "Azerbaijan",
        "native": "Azərbaycan",
        "dial_code": "+994",
        "iso2": "AZ",
        "mask": "+994-##-###-##-##",
        "emoji": "🇦🇿",
        "translations": {
            "es": "Azerbaiyán",
            "en": "Azerbaijan",
            "pt": "Azerbaijão"
        }
    },
    {
        "id": 18,
        "name": "Bahrain",
        "native": "‏البحرين",
        "dial_code": "+973",
        "iso2": "BH",
        "mask": "+973-####-####",
        "emoji": "🇧🇭",
        "translations": {
            "es": "Bahrein",
            "en": "Bahrain",
            "pt": "Bahrein"
        }
    },
    {
        "id": 19,
        "name": "Bangladesh",
        "native": "Bangladesh",
        "dial_code": "+880",
        "iso2": "BD",
        "mask": "+880-##-###-###",
        "emoji": "🇧🇩",
        "translations": {
            "es": "Bangladesh",
            "en": "Bangladesh",
            "pt": "Bangladesh"
        }
    },
    {
        "id": 20,
        "name": "Barbados",
        "native": "Barbados",
        "dial_code": "+1246",
        "iso2": "BB",
        "mask": "+1(246)###-####",
        "emoji": "🇧🇧",
        "translations": {
            "es": "Barbados",
            "en": "Barbados",
            "pt": "Barbados"
        }
    },
    {
        "id": 21,
        "name": "Belarus",
        "native": "Белару́сь",
        "dial_code": "+375",
        "iso2": "BY",
        "mask": "+375(##)###-##-##",
        "emoji": "🇧🇾",
        "translations": {
            "es": "Bielorrusia",
            "en": "Belarus",
            "pt": "Bielorrússia"
        }
    },
    {
        "id": 22,
        "name": "Belgium",
        "native": "België",
        "dial_code": "+32",
        "iso2": "BE",
        "mask": "+32(###)###-###",
        "emoji": "🇧🇪",
        "translations": {
            "es": "Bélgica",
            "en": "Belgium",
            "pt": "Bélgica"
        }
    },
    {
        "id": 23,
        "name": "Belize",
        "native": "Belize",
        "dial_code": "+501",
        "iso2": "BZ",
        "mask": "+501-###-####",
        "emoji": "🇧🇿",
        "translations": {
            "es": "Belice",
            "en": "Belize",
            "pt": "Belize"
        }
    },
    {
        "id": 24,
        "name": "Benin",
        "native": "Bénin",
        "dial_code": "+229",
        "iso2": "BJ",
        "mask": "+229-##-##-####",
        "emoji": "🇧🇯",
        "translations": {
            "es": "Benín",
            "en": "Benin",
            "pt": "Benin"
        }
    },
    {
        "id": 25,
        "name": "Bermuda",
        "native": "Bermuda",
        "dial_code": "+1441",
        "iso2": "BM",
        "mask": "+1(441)###-####",
        "emoji": "🇧🇲",
        "translations": {
            "es": "Bermudas",
            "en": "Bermuda",
            "pt": "Bermudas"
        }
    },
    {
        "id": 26,
        "name": "Bhutan",
        "native": "ʼbrug-yul",
        "dial_code": "+975",
        "iso2": "BT",
        "mask": "+975-#-###-###",
        "emoji": "🇧🇹",
        "translations": {
            "es": "Bután",
            "en": "Bhutan",
            "pt": "Butão"
        }
    },
    {
        "id": 27,
        "name": "Bolivia",
        "native": "Bolivia",
        "dial_code": "+591",
        "iso2": "BO",
        "mask": "+591-#-###-####",
        "emoji": "🇧🇴",
        "translations": {
            "es": "Bolivia",
            "en": "Bolivia",
            "pt": "Bolívia"
        }
    },
    {
        "id": 155,
        "name": "Bonaire, Sint Eustatius and Saba",
        "native": "Caribisch Nederland",
        "dial_code": "+599",
        "iso2": "BQ",
        "mask": "",
        "emoji": "🇧🇶",
        "translations": {
            "en": "Bonaire, Sint Eustatius and Saba",
            "pt": "Bonaire"
        }
    },
    {
        "id": 28,
        "name": "Bosnia and Herzegovina",
        "native": "Bosna i Hercegovina",
        "dial_code": "+387",
        "iso2": "BA",
        "mask": "+387-##-####",
        "emoji": "🇧🇦",
        "translations": {
            "es": "Bosnia y Herzegovina",
            "en": "Bosnia and Herzegovina",
            "pt": "Bósnia e Herzegovina"
        }
    },
    {
        "id": 29,
        "name": "Botswana",
        "native": "Botswana",
        "dial_code": "+267",
        "iso2": "BW",
        "mask": "+267-##-###-###",
        "emoji": "🇧🇼",
        "translations": {
            "es": "Botswana",
            "en": "Botswana",
            "pt": "Botsuana"
        }
    },
    {
        "id": 30,
        "name": "Bouvet Island",
        "native": "Bouvetøya",
        "dial_code": "+47",
        "iso2": "BV",
        "emoji": "🇧🇻",
        "translations": {
            "es": "Isla Bouvet",
            "en": "Bouvet Island",
            "pt": "Ilha Bouvet"
        }
    },
    {
        "id": 31,
        "name": "Brazil",
        "native": "Brasil",
        "dial_code": "+55",
        "iso2": "BR",
        "mask": "+55 (##) 9####-####",
        "masks": {
            "cpf": "###.###.###-##",
            "phone": "+55 (##) 9####-####",
            "address.zip": "#####-###",
            "vehicle.plate": "AAA-#X##",
        },
        "states": ['AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO'],
        "emoji": "🇧🇷",
        "translations": {
            "es": "Brasil",
            "en": "Brazil",
            "pt": "Brasil"
        }
    },
    {
        "id": 32,
        "name": "British Indian Ocean Territory",
        "native": "British Indian Ocean Territory",
        "dial_code": "+246",
        "iso2": "IO",
        "mask": "+246-###-####",
        "emoji": "🇮🇴",
        "translations": {
            "es": "Territorio Británico del Océano Índico",
            "en": "British Indian Ocean Territory",
            "pt": "Território Britânico do Oceano íÍdico"
        }
    },
    {
        "id": 33,
        "name": "Brunei",
        "native": "Negara Brunei Darussalam",
        "dial_code": "+673",
        "iso2": "BN",
        "mask": "+673-###-####",
        "emoji": "🇧🇳",
        "translations": {
            "es": "Brunei",
            "en": "Brunei",
            "pt": "Brunei"
        }
    },
    {
        "id": 34,
        "name": "Bulgaria",
        "native": "България",
        "dial_code": "+359",
        "iso2": "BG",
        "mask": "+359(###)###-###",
        "emoji": "🇧🇬",
        "translations": {
            "es": "Bulgaria",
            "en": "Bulgaria",
            "pt": "Bulgária"
        }
    },
    {
        "id": 35,
        "name": "Burkina Faso",
        "native": "Burkina Faso",
        "dial_code": "+226",
        "iso2": "BF",
        "mask": "+226-##-##-####",
        "emoji": "🇧🇫",
        "translations": {
            "es": "Burkina Faso",
            "en": "Burkina Faso",
            "pt": "Burkina Faso"
        }
    },
    {
        "id": 36,
        "name": "Burundi",
        "native": "Burundi",
        "dial_code": "+257",
        "iso2": "BI",
        "mask": "+257-##-##-####",
        "emoji": "🇧🇮",
        "translations": {
            "es": "Burundi",
            "en": "Burundi",
            "pt": "Burundi"
        }
    },
    {
        "id": 37,
        "name": "Cambodia",
        "native": "Kâmpŭchéa",
        "dial_code": "+855",
        "iso2": "KH",
        "mask": "+855-##-###-###",
        "emoji": "🇰🇭",
        "translations": {
            "es": "Camboya",
            "en": "Cambodia",
            "pt": "Camboja"
        }
    },
    {
        "id": 38,
        "name": "Cameroon",
        "native": "Cameroon",
        "dial_code": "+237",
        "iso2": "CM",
        "mask": "+237-####-####",
        "emoji": "🇨🇲",
        "translations": {
            "es": "Camerún",
            "en": "Cameroon",
            "pt": "Camarões"
        }
    },
    {
        "id": 39,
        "name": "Canada",
        "native": "Canada",
        "dial_code": "+1",
        "iso2": "CA",
        "mask": "+1(###)###-####",
        "emoji": "🇨🇦",
        "translations": {
            "es": "Canadá",
            "en": "Canada",
            "pt": "Canadá"
        }
    },
    {
        "id": 40,
        "name": "Cape Verde",
        "native": "Cabo Verde",
        "dial_code": "+238",
        "iso2": "CV",
        "mask": "+238(###)##-##",
        "emoji": "🇨🇻",
        "translations": {
            "es": "Cabo Verde",
            "en": "Cape Verde",
            "pt": "Cabo Verde"
        }
    },
    {
        "id": 41,
        "name": "Cayman Islands",
        "native": "Cayman Islands",
        "dial_code": "+1345",
        "iso2": "KY",
        "mask": "+1(345)###-####",
        "emoji": "🇰🇾",
        "translations": {
            "es": "Islas Caimán",
            "en": "Cayman Islands",
            "pt": "Ilhas Cayman"
        }
    },
    {
        "id": 42,
        "name": "Central African Republic",
        "native": "Ködörösêse tî Bêafrîka",
        "dial_code": "+236",
        "iso2": "CF",
        "mask": "+236-##-##-####",
        "emoji": "🇨🇫",
        "translations": {
            "es": "República Centroafricana",
            "en": "Central African Republic",
            "pt": "República Centro-Africana"
        }
    },
    {
        "id": 43,
        "name": "Chad",
        "native": "Tchad",
        "dial_code": "+235",
        "iso2": "TD",
        "mask": "+235-##-##-##-##",
        "emoji": "🇹🇩",
        "translations": {
            "es": "Chad",
            "en": "Chad",
            "pt": "Chade"
        }
    },
    {
        "id": 44,
        "name": "Chile",
        "native": "Chile",
        "dial_code": "+56",
        "iso2": "CL",
        "mask": "+56-#-####-####",
        "emoji": "🇨🇱",
        "translations": {
            "es": "Chile",
            "en": "Chile",
            "pt": "Chile"
        }
    },
    {
        "id": 45,
        "name": "China",
        "native": "中国",
        "dial_code": "+86",
        "iso2": "CN",
        "mask": "+86-##-#####-#####",
        "emoji": "🇨🇳",
        "translations": {
            "es": "China",
            "en": "China",
            "pt": "China"
        }
    },
    {
        "id": 46,
        "name": "Christmas Island",
        "native": "Christmas Island",
        "dial_code": "+61",
        "iso2": "CX",
        "emoji": "🇨🇽",
        "translations": {
            "es": "Isla de Navidad",
            "en": "Christmas Island",
            "pt": "Ilha Christmas"
        }
    },
    {
        "id": 47,
        "name": "Cocos (Keeling) Islands",
        "native": "Cocos (Keeling) Islands",
        "dial_code": "+61",
        "iso2": "CC",
        "emoji": "🇨🇨",
        "translations": {
            "es": "Islas Cocos o Islas Keeling",
            "en": "Cocos (Keeling) Islands",
            "pt": "Ilhas Cocos"
        }
    },
    {
        "id": 48,
        "name": "Colombia",
        "native": "Colombia",
        "dial_code": "+57",
        "iso2": "CO",
        "mask": "+57(###)###-####",
        "emoji": "🇨🇴",
        "translations": {
            "es": "Colombia",
            "en": "Colombia",
            "pt": "Colômbia"
        }
    },
    {
        "id": 49,
        "name": "Comoros",
        "native": "Komori",
        "dial_code": "+269",
        "iso2": "KM",
        "mask": "+269-##-#####",
        "emoji": "🇰🇲",
        "translations": {
            "es": "Comoras",
            "en": "Comoros",
            "pt": "Comores"
        }
    },
    {
        "id": 50,
        "name": "Congo",
        "native": "République du Congo",
        "dial_code": "+242",
        "iso2": "CG",
        "mask": "+242-##-###-####",
        "emoji": "🇨🇬",
        "translations": {
            "es": "Congo",
            "en": "Congo",
            "pt": "Congo"
        }
    },
    {
        "id": 52,
        "name": "Cook Islands",
        "native": "Cook Islands",
        "dial_code": "+682",
        "iso2": "CK",
        "mask": "+682-##-###",
        "emoji": "🇨🇰",
        "translations": {
            "es": "Islas Cook",
            "en": "Cook Islands",
            "pt": "Ilhas Cook"
        }
    },
    {
        "id": 53,
        "name": "Costa Rica",
        "native": "Costa Rica",
        "dial_code": "+506",
        "iso2": "CR",
        "mask": "+506-####-####",
        "emoji": "🇨🇷",
        "translations": {
            "es": "Costa Rica",
            "en": "Costa Rica",
            "pt": "Costa Rica"
        }
    },
    {
        "id": 54,
        "name": "Cote D'Ivoire (Ivory Coast)",
        "native": null,
        "dial_code": "+225",
        "iso2": "CI",
        "mask": "+225-##-###-###",
        "emoji": "🇨🇮",
        "translations": {
            "es": "Costa de Marfil",
            "en": "Cote D'Ivoire (Ivory Coast)",
            "pt": "Costa do Marfim"
        }
    },
    {
        "id": 55,
        "name": "Croatia",
        "native": "Hrvatska",
        "dial_code": "+385",
        "iso2": "HR",
        "mask": "+385-##-###-###",
        "emoji": "🇭🇷",
        "translations": {
            "es": "Croacia",
            "en": "Croatia",
            "pt": "Croácia"
        }
    },
    {
        "id": 56,
        "name": "Cuba",
        "native": "Cuba",
        "dial_code": "+53",
        "iso2": "CU",
        "mask": "+53-#-###-####",
        "emoji": "🇨🇺",
        "translations": {
            "es": "Cuba",
            "en": "Cuba",
            "pt": "Cuba"
        }
    },
    {
        "id": 249,
        "name": "Curaçao",
        "native": "Curaçao",
        "dial_code": "+599",
        "iso2": "CW",
        "mask": "",
        "emoji": "🇨🇼",
        "translations": {
            "en": "Curaçao",
            "pt": "Curaçao"
        }
    },
    {
        "id": 57,
        "name": "Cyprus",
        "native": "Κύπρος",
        "dial_code": "+357",
        "iso2": "CY",
        "mask": "+357-##-###-###",
        "emoji": "🇨🇾",
        "translations": {
            "es": "Chipre",
            "en": "Cyprus",
            "pt": "Chipre"
        }
    },
    {
        "id": 58,
        "name": "Czech Republic",
        "native": "Česká republika",
        "dial_code": "+420",
        "iso2": "CZ",
        "mask": "+420(###)###-###",
        "emoji": "🇨🇿",
        "translations": {
            "es": "República Checa",
            "en": "Czech Republic",
            "pt": "República Tcheca"
        }
    },
    {
        "id": 51,
        "name": "Democratic Republic of the Congo",
        "native": "République démocratique du Congo",
        "dial_code": "+243",
        "iso2": "CD",
        "mask": "+243(###)###-###",
        "emoji": "🇨🇩",
        "translations": {
            "es": "Congo (Rep. Dem.)",
            "en": "Democratic Republic of the Congo",
            "pt": "RD Congo"
        }
    },
    {
        "id": 59,
        "name": "Denmark",
        "native": "Danmark",
        "dial_code": "+45",
        "iso2": "DK",
        "mask": "+45-##-##-##-##",
        "emoji": "🇩🇰",
        "translations": {
            "es": "Dinamarca",
            "en": "Denmark",
            "pt": "Dinamarca"
        }
    },
    {
        "id": 60,
        "name": "Djibouti",
        "native": "Djibouti",
        "dial_code": "+253",
        "iso2": "DJ",
        "mask": "+253-##-##-##-##",
        "emoji": "🇩🇯",
        "translations": {
            "es": "Yibuti",
            "en": "Djibouti",
            "pt": "Djibuti"
        }
    },
    {
        "id": 61,
        "name": "Dominica",
        "native": "Dominica",
        "dial_code": "+1767",
        "iso2": "DM",
        "mask": "+1(767)###-####",
        "emoji": "🇩🇲",
        "translations": {
            "es": "Dominica",
            "en": "Dominica",
            "pt": "Dominica"
        }
    },
    {
        "id": 62,
        "name": "Dominican Republic",
        "native": "República Dominicana",
        "dial_code": "+1849",
        "iso2": "DO",
        "mask": "+1(849)###-####",
        "emoji": "🇩🇴",
        "translations": {
            "es": "República Dominicana",
            "en": "Dominican Republic",
            "pt": "República Dominicana"
        }
    },
    {
        "id": 63,
        "name": "East Timor",
        "native": "Timor-Leste",
        "dial_code": "+670",
        "iso2": "TL",
        "mask": "+670-78#-#####",
        "emoji": "🇹🇱",
        "translations": {
            "es": "Timor Oriental",
            "en": "East Timor",
            "pt": "Timor Leste"
        }
    },
    {
        "id": 64,
        "name": "Ecuador",
        "native": "Ecuador",
        "dial_code": "+593",
        "iso2": "EC",
        "mask": "+593-#-###-####",
        "emoji": "🇪🇨",
        "translations": {
            "es": "Ecuador",
            "en": "Ecuador",
            "pt": "Equador"
        }
    },
    {
        "id": 65,
        "name": "Egypt",
        "native": "مصر‎",
        "dial_code": "+20",
        "iso2": "EG",
        "mask": "+20(###)###-####",
        "emoji": "🇪🇬",
        "translations": {
            "es": "Egipto",
            "en": "Egypt",
            "pt": "Egito"
        }
    },
    {
        "id": 66,
        "name": "El Salvador",
        "native": "El Salvador",
        "dial_code": "+503",
        "iso2": "SV",
        "mask": "+503-##-##-####",
        "emoji": "🇸🇻",
        "translations": {
            "es": "El Salvador",
            "en": "El Salvador",
            "pt": "El Salvador"
        }
    },
    {
        "id": 67,
        "name": "Equatorial Guinea",
        "native": "Guinea Ecuatorial",
        "dial_code": "+240",
        "iso2": "GQ",
        "mask": "+240-##-###-####",
        "emoji": "🇬🇶",
        "translations": {
            "es": "Guinea Ecuatorial",
            "en": "Equatorial Guinea",
            "pt": "Guiné Equatorial"
        }
    },
    {
        "id": 68,
        "name": "Eritrea",
        "native": "ኤርትራ",
        "dial_code": "+291",
        "iso2": "ER",
        "mask": "+291-#-###-###",
        "emoji": "🇪🇷",
        "translations": {
            "es": "Eritrea",
            "en": "Eritrea",
            "pt": "Eritreia"
        }
    },
    {
        "id": 69,
        "name": "Estonia",
        "native": "Eesti",
        "dial_code": "+372",
        "iso2": "EE",
        "mask": "+372-###-####",
        "emoji": "🇪🇪",
        "translations": {
            "es": "Estonia",
            "en": "Estonia",
            "pt": "Estônia"
        }
    },
    {
        "id": 70,
        "name": "Ethiopia",
        "native": "ኢትዮጵያ",
        "dial_code": "+251",
        "iso2": "ET",
        "mask": "+251-##-###-####",
        "emoji": "🇪🇹",
        "translations": {
            "es": "Etiopía",
            "en": "Ethiopia",
            "pt": "Etiópia"
        }
    },
    {
        "id": 71,
        "name": "Falkland Islands",
        "native": "Falkland Islands",
        "dial_code": "+500",
        "iso2": "FK",
        "mask": "+500-#####",
        "emoji": "🇫🇰",
        "translations": {
            "es": "Islas Malvinas",
            "en": "Falkland Islands",
            "pt": "Ilhas Malvinas"
        }
    },
    {
        "id": 72,
        "name": "Faroe Islands",
        "native": "Føroyar",
        "dial_code": "+298",
        "iso2": "FO",
        "mask": "+298-###-###",
        "emoji": "🇫🇴",
        "translations": {
            "es": "Islas Faroe",
            "en": "Faroe Islands",
            "pt": "Ilhas Faroé"
        }
    },
    {
        "id": 73,
        "name": "Fiji Islands",
        "native": "Fiji",
        "dial_code": "+679",
        "iso2": "FJ",
        "mask": "+679-##-#####",
        "emoji": "🇫🇯",
        "translations": {
            "es": "Fiyi",
            "en": "Fiji Islands",
            "pt": "Fiji"
        }
    },
    {
        "id": 74,
        "name": "Finland",
        "native": "Suomi",
        "dial_code": "+358",
        "iso2": "FI",
        "mask": "+358(###)###-##-##",
        "emoji": "🇫🇮",
        "translations": {
            "es": "Finlandia",
            "en": "Finland",
            "pt": "Finlândia"
        }
    },
    {
        "id": 75,
        "name": "France",
        "native": "France",
        "dial_code": "+33",
        "iso2": "FR",
        "mask": "+590(###)###-###",
        "emoji": "🇫🇷",
        "translations": {
            "es": "Francia",
            "en": "France",
            "pt": "França"
        }
    },
    {
        "id": 76,
        "name": "French Guiana",
        "native": "Guyane française",
        "dial_code": "+594",
        "iso2": "GF",
        "mask": "+594-#####-####",
        "emoji": "🇬🇫",
        "translations": {
            "es": "Guayana Francesa",
            "en": "French Guiana",
            "pt": "Guiana Francesa"
        }
    },
    {
        "id": 77,
        "name": "French Polynesia",
        "native": "Polynésie française",
        "dial_code": "+689",
        "iso2": "PF",
        "mask": "+689-##-##-##",
        "emoji": "🇵🇫",
        "translations": {
            "es": "Polinesia Francesa",
            "en": "French Polynesia",
            "pt": "Polinésia Francesa"
        }
    },
    {
        "id": 78,
        "name": "French Southern Territories",
        "native": "Territoire des Terres australes et antarctiques fr",
        "dial_code": "+262",
        "iso2": "TF",
        "mask": "",
        "emoji": "🇹🇫",
        "translations": {
            "es": "Tierras Australes y Antárticas Francesas",
            "en": "French Southern Territories",
            "pt": "Terras Austrais e Antárticas Francesas"
        }
    },
    {
        "id": 79,
        "name": "Gabon",
        "native": "Gabon",
        "dial_code": "+241",
        "iso2": "GA",
        "mask": "+241-#-##-##-##",
        "emoji": "🇬🇦",
        "translations": {
            "es": "Gabón",
            "en": "Gabon",
            "pt": "Gabão"
        }
    },
    {
        "id": 80,
        "name": "Gambia The",
        "native": "Gambia",
        "dial_code": "+220",
        "iso2": "GM",
        "mask": "+220(###)##-##",
        "emoji": "🇬🇲",
        "translations": {
            "es": "Gambia",
            "en": "Gambia The",
            "pt": "Gâmbia"
        }
    },
    {
        "id": 81,
        "name": "Georgia",
        "native": "საქართველო",
        "dial_code": "+995",
        "iso2": "GE",
        "mask": "+995(###)###-###",
        "emoji": "🇬🇪",
        "translations": {
            "es": "Georgia",
            "en": "Georgia",
            "pt": "Geórgia"
        }
    },
    {
        "id": 82,
        "name": "Germany",
        "native": "Deutschland",
        "dial_code": "+49",
        "iso2": "DE",
        "mask": "+49-###-###",
        "emoji": "🇩🇪",
        "translations": {
            "es": "Alemania",
            "en": "Germany",
            "pt": "Alemanha"
        }
    },
    {
        "id": 83,
        "name": "Ghana",
        "native": "Ghana",
        "dial_code": "+233",
        "iso2": "GH",
        "mask": "+233(###)###-###",
        "emoji": "🇬🇭",
        "translations": {
            "es": "Ghana",
            "en": "Ghana",
            "pt": "Gana"
        }
    },
    {
        "id": 84,
        "name": "Gibraltar",
        "native": "Gibraltar",
        "dial_code": "+350",
        "iso2": "GI",
        "mask": "+350-###-#####",
        "emoji": "🇬🇮",
        "translations": {
            "es": "Gibraltar",
            "en": "Gibraltar",
            "pt": "Gibraltar"
        }
    },
    {
        "id": 85,
        "name": "Greece",
        "native": "Ελλάδα",
        "dial_code": "+30",
        "iso2": "GR",
        "mask": "+30(###)###-####",
        "emoji": "🇬🇷",
        "translations": {
            "es": "Grecia",
            "en": "Greece",
            "pt": "Grécia"
        }
    },
    {
        "id": 86,
        "name": "Greenland",
        "native": "Kalaallit Nunaat",
        "dial_code": "+299",
        "iso2": "GL",
        "mask": "+299-##-##-##",
        "emoji": "🇬🇱",
        "translations": {
            "es": "Groenlandia",
            "en": "Greenland",
            "pt": "Groelândia"
        }
    },
    {
        "id": 87,
        "name": "Grenada",
        "native": "Grenada",
        "dial_code": "+1473",
        "iso2": "GD",
        "mask": "+1(473)###-####",
        "emoji": "🇬🇩",
        "translations": {
            "es": "Grenada",
            "en": "Grenada",
            "pt": "Granada"
        }
    },
    {
        "id": 88,
        "name": "Guadeloupe",
        "native": "Guadeloupe",
        "dial_code": "+590",
        "iso2": "GP",
        "emoji": "🇬🇵",
        "translations": {
            "es": "Guadalupe",
            "en": "Guadeloupe",
            "pt": "Guadalupe"
        }
    },
    {
        "id": 89,
        "name": "Guam",
        "native": "Guam",
        "dial_code": "+1671",
        "iso2": "GU",
        "mask": "+1(671)###-####",
        "emoji": "🇬🇺",
        "translations": {
            "es": "Guam",
            "en": "Guam",
            "pt": "Guam"
        }
    },
    {
        "id": 90,
        "name": "Guatemala",
        "native": "Guatemala",
        "dial_code": "+502",
        "iso2": "GT",
        "mask": "+502-#-###-####",
        "emoji": "🇬🇹",
        "translations": {
            "es": "Guatemala",
            "en": "Guatemala",
            "pt": "Guatemala"
        }
    },
    {
        "id": 91,
        "name": "Guernsey and Alderney",
        "native": "Guernsey",
        "dial_code": "+44",
        "iso2": "GG",
        "emoji": "🇬🇬",
        "translations": {
            "es": "Guernsey",
            "en": "Guernsey and Alderney",
            "pt": "Guernsey"
        }
    },
    {
        "id": 92,
        "name": "Guinea",
        "native": "Guinée",
        "dial_code": "+224",
        "iso2": "GN",
        "mask": "+224-##-###-###",
        "emoji": "🇬🇳",
        "translations": {
            "es": "Guinea",
            "en": "Guinea",
            "pt": "Guiné"
        }
    },
    {
        "id": 93,
        "name": "Guinea-Bissau",
        "native": "Guiné-Bissau",
        "dial_code": "+245",
        "iso2": "GW",
        "mask": "+245-#-######",
        "emoji": "🇬🇼",
        "translations": {
            "es": "Guinea-Bisáu",
            "en": "Guinea-Bissau",
            "pt": "Guiné-Bissau"
        }
    },
    {
        "id": 94,
        "name": "Guyana",
        "native": "Guyana",
        "dial_code": "+592",
        "iso2": "GY",
        "mask": "+592-###-####",
        "emoji": "🇬🇾",
        "translations": {
            "es": "Guyana",
            "en": "Guyana",
            "pt": "Guiana"
        }
    },
    {
        "id": 95,
        "name": "Haiti",
        "native": "Haïti",
        "dial_code": "+509",
        "iso2": "HT",
        "mask": "+509-##-##-####",
        "emoji": "🇭🇹",
        "translations": {
            "es": "Haiti",
            "en": "Haiti",
            "pt": "Haiti"
        }
    },
    {
        "id": 96,
        "name": "Heard Island and McDonald Islands",
        "native": "Heard Island and McDonald Islands",
        "dial_code": "+672",
        "iso2": "HM",
        "emoji": "🇭🇲",
        "translations": {
            "es": "Islas Heard y McDonald",
            "en": "Heard Island and McDonald Islands",
            "pt": "Ilha Heard e Ilhas McDonald"
        }
    },
    {
        "id": 97,
        "name": "Honduras",
        "native": "Honduras",
        "dial_code": "+504",
        "iso2": "HN",
        "mask": "+504-####-####",
        "emoji": "🇭🇳",
        "translations": {
            "es": "Honduras",
            "en": "Honduras",
            "pt": "Honduras"
        }
    },
    {
        "id": 98,
        "name": "Hong Kong S.A.R.",
        "native": "香港",
        "dial_code": "+852",
        "iso2": "HK",
        "mask": "+852-####-####",
        "emoji": "🇭🇰",
        "translations": {
            "es": "Hong Kong",
            "en": "Hong Kong S.A.R.",
            "pt": "Hong Kong"
        }
    },
    {
        "id": 99,
        "name": "Hungary",
        "native": "Magyarország",
        "dial_code": "+36",
        "iso2": "HU",
        "mask": "+36(###)###-###",
        "emoji": "🇭🇺",
        "translations": {
            "es": "Hungría",
            "en": "Hungary",
            "pt": "Hungria"
        }
    },
    {
        "id": 100,
        "name": "Iceland",
        "native": "Ísland",
        "dial_code": "+354",
        "iso2": "IS",
        "mask": "+354-###-####",
        "emoji": "🇮🇸",
        "translations": {
            "es": "Islandia",
            "en": "Iceland",
            "pt": "Islândia"
        }
    },
    {
        "id": 101,
        "name": "India",
        "native": "भारत",
        "dial_code": "+91",
        "iso2": "IN",
        "mask": "+91(####)###-###",
        "emoji": "🇮🇳",
        "translations": {
            "es": "India",
            "en": "India",
            "pt": "Índia"
        }
    },
    {
        "id": 102,
        "name": "Indonesia",
        "native": "Indonesia",
        "dial_code": "+62",
        "iso2": "ID",
        "mask": "+62(8##)###-##-###",
        "emoji": "🇮🇩",
        "translations": {
            "es": "Indonesia",
            "en": "Indonesia",
            "pt": "Indonésia"
        }
    },
    {
        "id": 103,
        "name": "Iran",
        "native": "ایران",
        "dial_code": "+98",
        "iso2": "IR",
        "mask": "+98(###)###-####",
        "emoji": "🇮🇷",
        "translations": {
            "es": "Iran",
            "en": "Iran",
            "pt": "Irã"
        }
    },
    {
        "id": 104,
        "name": "Iraq",
        "native": "العراق",
        "dial_code": "+964",
        "iso2": "IQ",
        "mask": "+964(###)###-####",
        "emoji": "🇮🇶",
        "translations": {
            "es": "Irak",
            "en": "Iraq",
            "pt": "Iraque"
        }
    },
    {
        "id": 105,
        "name": "Ireland",
        "native": "Éire",
        "dial_code": "+353",
        "iso2": "IE",
        "mask": "+353(##)###-####",
        "emoji": "🇮🇪",
        "translations": {
            "es": "Irlanda",
            "en": "Ireland",
            "pt": "Irlanda"
        }
    },
    {
        "id": 106,
        "name": "Israel",
        "native": "יִשְׂרָאֵל",
        "dial_code": "+972",
        "iso2": "IL",
        "mask": "+972-#-###-####",
        "emoji": "🇮🇱",
        "translations": {
            "es": "Israel",
            "en": "Israel",
            "pt": "Israel"
        }
    },
    {
        "id": 107,
        "name": "Italy",
        "native": "Italia",
        "dial_code": "+39",
        "iso2": "IT",
        "mask": "+39(###)####-###",
        "emoji": "🇮🇹",
        "translations": {
            "es": "Italia",
            "en": "Italy",
            "pt": "Itália"
        }
    },
    {
        "id": 108,
        "name": "Jamaica",
        "native": "Jamaica",
        "dial_code": "+1876",
        "iso2": "JM",
        "mask": "+1(876)###-####",
        "emoji": "🇯🇲",
        "translations": {
            "es": "Jamaica",
            "en": "Jamaica",
            "pt": "Jamaica"
        }
    },
    {
        "id": 109,
        "name": "Japan",
        "native": "日本",
        "dial_code": "+81",
        "iso2": "JP",
        "mask": "+81(###)###-###",
        "emoji": "🇯🇵",
        "translations": {
            "es": "Japón",
            "en": "Japan",
            "pt": "Japão"
        }
    },
    {
        "id": 110,
        "name": "Jersey",
        "native": "Jersey",
        "dial_code": "+44",
        "iso2": "JE",
        "emoji": "🇯🇪",
        "translations": {
            "es": "Jersey",
            "en": "Jersey",
            "pt": "Jersey"
        }
    },
    {
        "id": 111,
        "name": "Jordan",
        "native": "الأردن",
        "dial_code": "+962",
        "iso2": "JO",
        "mask": "+962-#-####-####",
        "emoji": "🇯🇴",
        "translations": {
            "es": "Jordania",
            "en": "Jordan",
            "pt": "Jordânia"
        }
    },
    {
        "id": 112,
        "name": "Kazakhstan",
        "native": "Қазақстан",
        "dial_code": "+77",
        "iso2": "KZ",
        "mask": "+7(7##)###-##-##",
        "emoji": "🇰🇿",
        "translations": {
            "es": "Kazajistán",
            "en": "Kazakhstan",
            "pt": "Cazaquistão"
        }
    },
    {
        "id": 113,
        "name": "Kenya",
        "native": "Kenya",
        "dial_code": "+254",
        "iso2": "KE",
        "mask": "+254-###-######",
        "emoji": "🇰🇪",
        "translations": {
            "es": "Kenia",
            "en": "Kenya",
            "pt": "Quênia"
        }
    },
    {
        "id": 114,
        "name": "Kiribati",
        "native": "Kiribati",
        "dial_code": "+686",
        "iso2": "KI",
        "mask": "+686-##-###",
        "emoji": "🇰🇮",
        "translations": {
            "es": "Kiribati",
            "en": "Kiribati",
            "pt": "Kiribati"
        }
    },
    {
        "id": 248,
        "name": "Kosovo",
        "native": "Republika e Kosovës",
        "dial_code": "+383",
        "iso2": "XK",
        "emoji": "🇽🇰",
        "translations": {
            "en": "Kosovo"
        }
    },
    {
        "id": 117,
        "name": "Kuwait",
        "native": "الكويت",
        "dial_code": "+965",
        "iso2": "KW",
        "mask": "+965-####-####",
        "emoji": "🇰🇼",
        "translations": {
            "es": "Kuwait",
            "en": "Kuwait",
            "pt": "Kuwait"
        }
    },
    {
        "id": 118,
        "name": "Kyrgyzstan",
        "native": "Кыргызстан",
        "dial_code": "+996",
        "iso2": "KG",
        "mask": "+996(###)###-###",
        "emoji": "🇰🇬",
        "translations": {
            "es": "Kirguizistán",
            "en": "Kyrgyzstan",
            "pt": "Quirguistão"
        }
    },
    {
        "id": 119,
        "name": "Laos",
        "native": "ສປປລາວ",
        "dial_code": "+856",
        "iso2": "LA",
        "mask": "+856-##-###-###",
        "emoji": "🇱🇦",
        "translations": {
            "es": "Laos",
            "en": "Laos",
            "pt": "Laos"
        }
    },
    {
        "id": 120,
        "name": "Latvia",
        "native": "Latvija",
        "dial_code": "+371",
        "iso2": "LV",
        "mask": "+371-##-###-###",
        "emoji": "🇱🇻",
        "translations": {
            "es": "Letonia",
            "en": "Latvia",
            "pt": "Letônia"
        }
    },
    {
        "id": 121,
        "name": "Lebanon",
        "native": "لبنان",
        "dial_code": "+961",
        "iso2": "LB",
        "mask": "+961-#-###-###",
        "emoji": "🇱🇧",
        "translations": {
            "es": "Líbano",
            "en": "Lebanon",
            "pt": "Líbano"
        }
    },
    {
        "id": 122,
        "name": "Lesotho",
        "native": "Lesotho",
        "dial_code": "+266",
        "iso2": "LS",
        "mask": "+266-#-###-####",
        "emoji": "🇱🇸",
        "translations": {
            "es": "Lesotho",
            "en": "Lesotho",
            "pt": "Lesoto"
        }
    },
    {
        "id": 123,
        "name": "Liberia",
        "native": "Liberia",
        "dial_code": "+231",
        "iso2": "LR",
        "mask": "+231-##-###-###",
        "emoji": "🇱🇷",
        "translations": {
            "es": "Liberia",
            "en": "Liberia",
            "pt": "Libéria"
        }
    },
    {
        "id": 124,
        "name": "Libya",
        "native": "‏ليبيا",
        "dial_code": "+218",
        "iso2": "LY",
        "mask": "+218-21-###-####",
        "emoji": "🇱🇾",
        "translations": {
            "es": "Libia",
            "en": "Libya",
            "pt": "Líbia"
        }
    },
    {
        "id": 125,
        "name": "Liechtenstein",
        "native": "Liechtenstein",
        "dial_code": "+423",
        "iso2": "LI",
        "mask": "+423(###)###-####",
        "emoji": "🇱🇮",
        "translations": {
            "es": "Liechtenstein",
            "en": "Liechtenstein",
            "pt": "Liechtenstein"
        }
    },
    {
        "id": 126,
        "name": "Lithuania",
        "native": "Lietuva",
        "dial_code": "+370",
        "iso2": "LT",
        "mask": "+370(###)##-###",
        "emoji": "🇱🇹",
        "translations": {
            "es": "Lituania",
            "en": "Lithuania",
            "pt": "Lituânia"
        }
    },
    {
        "id": 127,
        "name": "Luxembourg",
        "native": "Luxembourg",
        "dial_code": "+352",
        "iso2": "LU",
        "mask": "+352(###)###-###",
        "emoji": "🇱🇺",
        "translations": {
            "es": "Luxemburgo",
            "en": "Luxembourg",
            "pt": "Luxemburgo"
        }
    },
    {
        "id": 128,
        "name": "Macau S.A.R.",
        "native": "澳門",
        "dial_code": "+853",
        "iso2": "MO",
        "mask": "+853-####-####",
        "emoji": "🇲🇴",
        "translations": {
            "es": "Macao",
            "en": "Macau S.A.R.",
            "pt": "Macau"
        }
    },
    {
        "id": 130,
        "name": "Madagascar",
        "native": "Madagasikara",
        "dial_code": "+261",
        "iso2": "MG",
        "mask": "+261-##-##-#####",
        "emoji": "🇲🇬",
        "translations": {
            "es": "Madagascar",
            "en": "Madagascar",
            "pt": "Madagascar"
        }
    },
    {
        "id": 131,
        "name": "Malawi",
        "native": "Malawi",
        "dial_code": "+265",
        "iso2": "MW",
        "mask": "+265-#-####-####",
        "emoji": "🇲🇼",
        "translations": {
            "es": "Malawi",
            "en": "Malawi",
            "pt": "Malawi"
        }
    },
    {
        "id": 132,
        "name": "Malaysia",
        "native": "Malaysia",
        "dial_code": "+60",
        "iso2": "MY",
        "mask": "+60-#-###-###",
        "emoji": "🇲🇾",
        "translations": {
            "es": "Malasia",
            "en": "Malaysia",
            "pt": "Malásia"
        }
    },
    {
        "id": 133,
        "name": "Maldives",
        "native": "Maldives",
        "dial_code": "+960",
        "iso2": "MV",
        "mask": "+960-###-####",
        "emoji": "🇲🇻",
        "translations": {
            "es": "Maldivas",
            "en": "Maldives",
            "pt": "Maldivas"
        }
    },
    {
        "id": 134,
        "name": "Mali",
        "native": "Mali",
        "dial_code": "+223",
        "iso2": "ML",
        "mask": "+223-##-##-####",
        "emoji": "🇲🇱",
        "translations": {
            "es": "Mali",
            "en": "Mali",
            "pt": "Mali"
        }
    },
    {
        "id": 135,
        "name": "Malta",
        "native": "Malta",
        "dial_code": "+356",
        "iso2": "MT",
        "mask": "+356-####-####",
        "emoji": "🇲🇹",
        "translations": {
            "es": "Malta",
            "en": "Malta",
            "pt": "Malta"
        }
    },
    {
        "id": 136,
        "name": "Man (Isle of)",
        "native": "Isle of Man",
        "dial_code": "+44",
        "iso2": "IM",
        "emoji": "🇮🇲",
        "translations": {
            "es": "Isla de Man",
            "en": "Man (Isle of)",
            "pt": "Ilha de Man"
        }
    },
    {
        "id": 137,
        "name": "Marshall Islands",
        "native": "M̧ajeļ",
        "dial_code": "+692",
        "iso2": "MH",
        "mask": "+692-###-####",
        "emoji": "🇲🇭",
        "translations": {
            "es": "Islas Marshall",
            "en": "Marshall Islands",
            "pt": "Ilhas Marshall"
        }
    },
    {
        "id": 138,
        "name": "Martinique",
        "native": "Martinique",
        "dial_code": "+596",
        "iso2": "MQ",
        "mask": "+596(###)##-##-##",
        "emoji": "🇲🇶",
        "translations": {
            "es": "Martinica",
            "en": "Martinique",
            "pt": "Martinica"
        }
    },
    {
        "id": 139,
        "name": "Mauritania",
        "native": "موريتانيا",
        "dial_code": "+222",
        "iso2": "MR",
        "mask": "+222-##-##-####",
        "emoji": "🇲🇷",
        "translations": {
            "es": "Mauritania",
            "en": "Mauritania",
            "pt": "Mauritânia"
        }
    },
    {
        "id": 140,
        "name": "Mauritius",
        "native": "Maurice",
        "dial_code": "+230",
        "iso2": "MU",
        "mask": "+230-###-####",
        "emoji": "🇲🇺",
        "translations": {
            "es": "Mauricio",
            "en": "Mauritius",
            "pt": "Maurício"
        }
    },
    {
        "id": 141,
        "name": "Mayotte",
        "native": "Mayotte",
        "dial_code": "+262",
        "iso2": "YT",
        "emoji": "🇾🇹",
        "translations": {
            "es": "Mayotte",
            "en": "Mayotte",
            "pt": "Mayotte"
        }
    },
    {
        "id": 142,
        "name": "Mexico",
        "native": "México",
        "dial_code": "+52",
        "iso2": "MX",
        "mask": "+52-##-##-####",
        "emoji": "🇲🇽",
        "translations": {
            "es": "México",
            "en": "Mexico",
            "pt": "México"
        }
    },
    {
        "id": 143,
        "name": "Micronesia",
        "native": "Micronesia",
        "dial_code": "+691",
        "iso2": "FM",
        "mask": "+691-###-####",
        "emoji": "🇫🇲",
        "translations": {
            "es": "Micronesia",
            "en": "Micronesia",
            "pt": "Micronésia"
        }
    },
    {
        "id": 144,
        "name": "Moldova",
        "native": "Moldova",
        "dial_code": "+373",
        "iso2": "MD",
        "mask": "+373-####-####",
        "emoji": "🇲🇩",
        "translations": {
            "es": "Moldavia",
            "en": "Moldova",
            "pt": "Moldávia"
        }
    },
    {
        "id": 145,
        "name": "Monaco",
        "native": "Monaco",
        "dial_code": "+377",
        "iso2": "MC",
        "mask": "+377-##-###-###",
        "emoji": "🇲🇨",
        "translations": {
            "es": "Mónaco",
            "en": "Monaco",
            "pt": "Mônaco"
        }
    },
    {
        "id": 146,
        "name": "Mongolia",
        "native": "Монгол улс",
        "dial_code": "+976",
        "iso2": "MN",
        "mask": "+976-##-##-####",
        "emoji": "🇲🇳",
        "translations": {
            "es": "Mongolia",
            "en": "Mongolia",
            "pt": "Mongólia"
        }
    },
    {
        "id": 147,
        "name": "Montenegro",
        "native": "Црна Гора",
        "dial_code": "+382",
        "iso2": "ME",
        "mask": "+382-##-###-###",
        "emoji": "🇲🇪",
        "translations": {
            "es": "Montenegro",
            "en": "Montenegro",
            "pt": "Montenegro"
        }
    },
    {
        "id": 148,
        "name": "Montserrat",
        "native": "Montserrat",
        "dial_code": "+1664",
        "iso2": "MS",
        "mask": "+1(664)###-####",
        "emoji": "🇲🇸",
        "translations": {
            "es": "Montserrat",
            "en": "Montserrat",
            "pt": "Montserrat"
        }
    },
    {
        "id": 149,
        "name": "Morocco",
        "native": "المغرب",
        "dial_code": "+212",
        "iso2": "MA",
        "mask": "+212-##-####-###",
        "emoji": "🇲🇦",
        "translations": {
            "es": "Marruecos",
            "en": "Morocco",
            "pt": "Marrocos"
        }
    },
    {
        "id": 150,
        "name": "Mozambique",
        "native": "Moçambique",
        "dial_code": "+258",
        "iso2": "MZ",
        "mask": "+258-##-###-###",
        "emoji": "🇲🇿",
        "translations": {
            "es": "Mozambique",
            "en": "Mozambique",
            "pt": "Moçambique"
        }
    },
    {
        "id": 151,
        "name": "Myanmar",
        "native": "မြန်မာ",
        "dial_code": "+95",
        "iso2": "MM",
        "mask": "+95-###-###",
        "emoji": "🇲🇲",
        "translations": {
            "es": "Myanmar",
            "en": "Myanmar",
            "pt": "Myanmar"
        }
    },
    {
        "id": 152,
        "name": "Namibia",
        "native": "Namibia",
        "dial_code": "+264",
        "iso2": "NA",
        "mask": "+264-##-###-####",
        "emoji": "🇳🇦",
        "translations": {
            "es": "Namibia",
            "en": "Namibia",
            "pt": "Namíbia"
        }
    },
    {
        "id": 153,
        "name": "Nauru",
        "native": "Nauru",
        "dial_code": "+674",
        "iso2": "NR",
        "mask": "+674-###-####",
        "emoji": "🇳🇷",
        "translations": {
            "es": "Nauru",
            "en": "Nauru",
            "pt": "Nauru"
        }
    },
    {
        "id": 154,
        "name": "Nepal",
        "native": "नपल",
        "dial_code": "+977",
        "iso2": "NP",
        "mask": "+977-##-###-###",
        "emoji": "🇳🇵",
        "translations": {
            "es": "Nepal",
            "en": "Nepal",
            "pt": "Nepal"
        }
    },
    {
        "id": 156,
        "name": "Netherlands",
        "native": "Nederland",
        "dial_code": "+31",
        "iso2": "NL",
        "mask": "+31-##-###-####",
        "emoji": "🇳🇱",
        "translations": {
            "es": "Países Bajos",
            "en": "Netherlands",
            "pt": "Holanda"
        }
    },
    {
        "id": 157,
        "name": "New Caledonia",
        "native": "Nouvelle-Calédonie",
        "dial_code": "+687",
        "iso2": "NC",
        "mask": "+687-##-####",
        "emoji": "🇳🇨",
        "translations": {
            "es": "Nueva Caledonia",
            "en": "New Caledonia",
            "pt": "Nova Caledônia"
        }
    },
    {
        "id": 158,
        "name": "New Zealand",
        "native": "New Zealand",
        "dial_code": "+64",
        "iso2": "NZ",
        "mask": "+64(###)###-####",
        "emoji": "🇳🇿",
        "translations": {
            "es": "Nueva Zelanda",
            "en": "New Zealand",
            "pt": "Nova Zelândia"
        }
    },
    {
        "id": 159,
        "name": "Nicaragua",
        "native": "Nicaragua",
        "dial_code": "+505",
        "iso2": "NI",
        "mask": "+505-####-####",
        "emoji": "🇳🇮",
        "translations": {
            "es": "Nicaragua",
            "en": "Nicaragua",
            "pt": "Nicarágua"
        }
    },
    {
        "id": 160,
        "name": "Niger",
        "native": "Niger",
        "dial_code": "+227",
        "iso2": "NE",
        "mask": "+227-##-##-####",
        "emoji": "🇳🇪",
        "translations": {
            "es": "Níger",
            "en": "Niger",
            "pt": "Níger"
        }
    },
    {
        "id": 161,
        "name": "Nigeria",
        "native": "Nigeria",
        "dial_code": "+234",
        "iso2": "NG",
        "mask": "+234(###)###-####",
        "emoji": "🇳🇬",
        "translations": {
            "es": "Nigeria",
            "en": "Nigeria",
            "pt": "Nigéria"
        }
    },
    {
        "id": 162,
        "name": "Niue",
        "native": "Niuē",
        "dial_code": "+683",
        "iso2": "NU",
        "mask": "+683-####",
        "emoji": "🇳🇺",
        "translations": {
            "es": "Niue",
            "en": "Niue",
            "pt": "Niue"
        }
    },
    {
        "id": 163,
        "name": "Norfolk Island",
        "native": "Norfolk Island",
        "dial_code": "+672",
        "iso2": "NF",
        "mask": "+672-3##-###",
        "emoji": "🇳🇫",
        "translations": {
            "es": "Isla de Norfolk",
            "en": "Norfolk Island",
            "pt": "Ilha Norfolk"
        }
    },
    {
        "id": 115,
        "name": "North Korea",
        "native": "북한",
        "dial_code": "+850",
        "iso2": "KP",
        "mask": "+850-####-#############",
        "emoji": "🇰🇵",
        "translations": {
            "es": "Corea del Norte",
            "en": "North Korea",
            "pt": "Coreia do Norte"
        }
    },
    {
        "id": 129,
        "name": "North Macedonia",
        "native": "Северна Македонија",
        "dial_code": "+389",
        "iso2": "MK",
        "mask": "+389-##-###-###",
        "emoji": "🇲🇰",
        "translations": {
            "es": "Macedonia del Norte",
            "en": "North Macedonia",
            "pt": "Macedônia do Norte"
        }
    },
    {
        "id": 164,
        "name": "Northern Mariana Islands",
        "native": "Northern Mariana Islands",
        "dial_code": "+1670",
        "iso2": "MP",
        "mask": "+1(670)###-####",
        "emoji": "🇲🇵",
        "translations": {
            "es": "Islas Marianas del Norte",
            "en": "Northern Mariana Islands",
            "pt": "Ilhas Marianas"
        }
    },
    {
        "id": 165,
        "name": "Norway",
        "native": "Norge",
        "dial_code": "+47",
        "iso2": "NO",
        "mask": "+47(###)##-###",
        "emoji": "🇳🇴",
        "translations": {
            "es": "Noruega",
            "en": "Norway",
            "pt": "Noruega"
        }
    },
    {
        "id": 166,
        "name": "Oman",
        "native": "عمان",
        "dial_code": "+968",
        "iso2": "OM",
        "mask": "+968-##-###-###",
        "emoji": "🇴🇲",
        "translations": {
            "es": "Omán",
            "en": "Oman",
            "pt": "Omã"
        }
    },
    {
        "id": 167,
        "name": "Pakistan",
        "native": "Pakistan",
        "dial_code": "+92",
        "iso2": "PK",
        "mask": "+92(###)###-####",
        "emoji": "🇵🇰",
        "translations": {
            "es": "Pakistán",
            "en": "Pakistan",
            "pt": "Paquistão"
        }
    },
    {
        "id": 168,
        "name": "Palau",
        "native": "Palau",
        "dial_code": "+680",
        "iso2": "PW",
        "mask": "+680-###-####",
        "emoji": "🇵🇼",
        "translations": {
            "es": "Palau",
            "en": "Palau",
            "pt": "Palau"
        }
    },
    {
        "id": 169,
        "name": "Palestinian Territory Occupied",
        "native": "فلسطين",
        "dial_code": "+970",
        "iso2": "PS",
        "mask": "+970-##-###-####",
        "emoji": "🇵🇸",
        "translations": {
            "es": "Palestina",
            "en": "Palestinian Territory Occupied",
            "pt": "Palestina"
        }
    },
    {
        "id": 170,
        "name": "Panama",
        "native": "Panamá",
        "dial_code": "+507",
        "iso2": "PA",
        "mask": "+507-###-####",
        "emoji": "🇵🇦",
        "translations": {
            "es": "Panamá",
            "en": "Panama",
            "pt": "Panamá"
        }
    },
    {
        "id": 171,
        "name": "Papua new Guinea",
        "native": "Papua Niugini",
        "dial_code": "+675",
        "iso2": "PG",
        "mask": "+675(###)##-###",
        "emoji": "🇵🇬",
        "translations": {
            "es": "Papúa Nueva Guinea",
            "en": "Papua new Guinea",
            "pt": "Papua Nova Guiné"
        }
    },
    {
        "id": 172,
        "name": "Paraguay",
        "native": "Paraguay",
        "dial_code": "+595",
        "iso2": "PY",
        "mask": "+595(###)###-###",
        "emoji": "🇵🇾",
        "translations": {
            "es": "Paraguay",
            "en": "Paraguay",
            "pt": "Paraguai"
        }
    },
    {
        "id": 173,
        "name": "Peru",
        "native": "Perú",
        "dial_code": "+51",
        "iso2": "PE",
        "mask": "+51(###)###-###",
        "emoji": "🇵🇪",
        "translations": {
            "es": "Perú",
            "en": "Peru",
            "pt": "Peru"
        }
    },
    {
        "id": 174,
        "name": "Philippines",
        "native": "Pilipinas",
        "dial_code": "+63",
        "iso2": "PH",
        "mask": "+63(###)###-####",
        "emoji": "🇵🇭",
        "translations": {
            "es": "Filipinas",
            "en": "Philippines",
            "pt": "Filipinas"
        }
    },
    {
        "id": 175,
        "name": "Pitcairn Island",
        "native": "Pitcairn Islands",
        "dial_code": "+64",
        "iso2": "PN",
        "emoji": "🇵🇳",
        "translations": {
            "es": "Islas Pitcairn",
            "en": "Pitcairn Island",
            "pt": "Ilhas Pitcairn"
        }
    },
    {
        "id": 176,
        "name": "Poland",
        "native": "Polska",
        "dial_code": "+48",
        "iso2": "PL",
        "mask": "+48(###)###-###",
        "emoji": "🇵🇱",
        "translations": {
            "es": "Polonia",
            "en": "Poland",
            "pt": "Polônia"
        }
    },
    {
        "id": 177,
        "name": "Portugal",
        "native": "Portugal",
        "dial_code": "+351",
        "iso2": "PT",
        "mask": "+351-##-###-####",
        "emoji": "🇵🇹",
        "translations": {
            "es": "Portugal",
            "en": "Portugal",
            "pt": "Portugal"
        }
    },
    {
        "id": 178,
        "name": "Puerto Rico",
        "native": "Puerto Rico",
        "dial_code": "+1939",
        "iso2": "PR",
        "emoji": "🇵🇷",
        "translations": {
            "es": "Puerto Rico",
            "en": "Puerto Rico",
            "pt": "Porto Rico"
        }
    },
    {
        "id": 179,
        "name": "Qatar",
        "native": "قطر",
        "dial_code": "+974",
        "iso2": "QA",
        "mask": "+974-####-####",
        "emoji": "🇶🇦",
        "translations": {
            "es": "Catar",
            "en": "Qatar",
            "pt": "Catar"
        }
    },
    {
        "id": 180,
        "name": "Reunion",
        "native": "La Réunion",
        "dial_code": "+262",
        "iso2": "RE",
        "mask": "+262-#####-####",
        "emoji": "🇷🇪",
        "translations": {
            "es": "Reunión",
            "en": "Reunion",
            "pt": "Reunião"
        }
    },
    {
        "id": 181,
        "name": "Romania",
        "native": "România",
        "dial_code": "+40",
        "iso2": "RO",
        "mask": "+40-##-###-####",
        "emoji": "🇷🇴",
        "translations": {
            "es": "Rumania",
            "en": "Romania",
            "pt": "Romênia"
        }
    },
    {
        "id": 182,
        "name": "Russia",
        "native": "Россия",
        "dial_code": "+7",
        "iso2": "RU",
        "mask": "+7(###)###-##-##",
        "emoji": "🇷🇺",
        "translations": {
            "es": "Rusia",
            "en": "Russia",
            "pt": "Rússia"
        }
    },
    {
        "id": 183,
        "name": "Rwanda",
        "native": "Rwanda",
        "dial_code": "+250",
        "iso2": "RW",
        "mask": "+250(###)###-###",
        "emoji": "🇷🇼",
        "translations": {
            "es": "Ruanda",
            "en": "Rwanda",
            "pt": "Ruanda"
        }
    },
    {
        "id": 184,
        "name": "Saint Helena",
        "native": "Saint Helena",
        "dial_code": "+290",
        "iso2": "SH",
        "mask": "+290-####",
        "emoji": "🇸🇭",
        "translations": {
            "es": "Santa Helena",
            "en": "Saint Helena",
            "pt": "Santa Helena"
        }
    },
    {
        "id": 185,
        "name": "Saint Kitts And Nevis",
        "native": "Saint Kitts and Nevis",
        "dial_code": "+1869",
        "iso2": "KN",
        "mask": "+1(869)###-####",
        "emoji": "🇰🇳",
        "translations": {
            "es": "San Cristóbal y Nieves",
            "en": "Saint Kitts And Nevis",
            "pt": "São Cristóvão e Neves"
        }
    },
    {
        "id": 186,
        "name": "Saint Lucia",
        "native": "Saint Lucia",
        "dial_code": "+1758",
        "iso2": "LC",
        "mask": "+1(758)###-####",
        "emoji": "🇱🇨",
        "translations": {
            "es": "Santa Lucía",
            "en": "Saint Lucia",
            "pt": "Santa Lúcia"
        }
    },
    {
        "id": 187,
        "name": "Saint Pierre and Miquelon",
        "native": "Saint-Pierre-et-Miquelon",
        "dial_code": "+508",
        "iso2": "PM",
        "emoji": "🇵🇲",
        "translations": {
            "es": "San Pedro y Miquelón",
            "en": "Saint Pierre and Miquelon",
            "pt": "Saint-Pierre e Miquelon"
        }
    },
    {
        "id": 188,
        "name": "Saint Vincent And The Grenadines",
        "native": "Saint Vincent and the Grenadines",
        "dial_code": "+1784",
        "iso2": "VC",
        "mask": "+1(784)###-####",
        "emoji": "🇻🇨",
        "translations": {
            "es": "San Vicente y Granadinas",
            "en": "Saint Vincent And The Grenadines",
            "pt": "São Vicente e Granadinas"
        }
    },
    {
        "id": 189,
        "name": "Saint-Barthelemy",
        "native": "Saint-Barthélemy",
        "dial_code": "+590",
        "iso2": "BL",
        "emoji": "🇧🇱",
        "translations": {
            "es": "San Bartolomé",
            "en": "Saint-Barthelemy",
            "pt": "São Bartolomeu"
        }
    },
    {
        "id": 190,
        "name": "Saint-Martin (French part)",
        "native": "Saint-Martin",
        "dial_code": "+590",
        "iso2": "MF",
        "emoji": "🇲🇫",
        "translations": {
            "es": "Saint Martin",
            "en": "Saint-Martin (French part)",
            "pt": "Saint Martin"
        }
    },
    {
        "id": 191,
        "name": "Samoa",
        "native": "Samoa",
        "dial_code": "+685",
        "iso2": "WS",
        "mask": "+685-##-####",
        "emoji": "🇼🇸",
        "translations": {
            "es": "Samoa",
            "en": "Samoa",
            "pt": "Samoa"
        }
    },
    {
        "id": 192,
        "name": "San Marino",
        "native": "San Marino",
        "dial_code": "+378",
        "iso2": "SM",
        "mask": "+378-####-######",
        "emoji": "🇸🇲",
        "translations": {
            "es": "San Marino",
            "en": "San Marino",
            "pt": "San Marino"
        }
    },
    {
        "id": 193,
        "name": "Sao Tome and Principe",
        "native": "São Tomé e Príncipe",
        "dial_code": "+239",
        "iso2": "ST",
        "mask": "+239-##-#####",
        "emoji": "🇸🇹",
        "translations": {
            "es": "Santo Tomé y Príncipe",
            "en": "Sao Tome and Principe",
            "pt": "São Tomé e Príncipe"
        }
    },
    {
        "id": 194,
        "name": "Saudi Arabia",
        "native": "المملكة العربية السعودية",
        "dial_code": "+966",
        "iso2": "SA",
        "mask": "+966-#-###-####",
        "emoji": "🇸🇦",
        "translations": {
            "es": "Arabia Saudí",
            "en": "Saudi Arabia",
            "pt": "Arábia Saudita"
        }
    },
    {
        "id": 195,
        "name": "Senegal",
        "native": "Sénégal",
        "dial_code": "+221",
        "iso2": "SN",
        "mask": "+221-##-###-####",
        "emoji": "🇸🇳",
        "translations": {
            "es": "Senegal",
            "en": "Senegal",
            "pt": "Senegal"
        }
    },
    {
        "id": 196,
        "name": "Serbia",
        "native": "Србија",
        "dial_code": "+381",
        "iso2": "RS",
        "mask": "+381-##-###-####",
        "emoji": "🇷🇸",
        "translations": {
            "es": "Serbia",
            "en": "Serbia",
            "pt": "Sérvia"
        }
    },
    {
        "id": 197,
        "name": "Seychelles",
        "native": "Seychelles",
        "dial_code": "+248",
        "iso2": "SC",
        "mask": "+248-#-###-###",
        "emoji": "🇸🇨",
        "translations": {
            "es": "Seychelles",
            "en": "Seychelles",
            "pt": "Seicheles"
        }
    },
    {
        "id": 198,
        "name": "Sierra Leone",
        "native": "Sierra Leone",
        "dial_code": "+232",
        "iso2": "SL",
        "mask": "+232-##-######",
        "emoji": "🇸🇱",
        "translations": {
            "es": "Sierra Leone",
            "en": "Sierra Leone",
            "pt": "Serra Leoa"
        }
    },
    {
        "id": 199,
        "name": "Singapore",
        "native": "Singapore",
        "dial_code": "+65",
        "iso2": "SG",
        "mask": "+65-####-####",
        "emoji": "🇸🇬",
        "translations": {
            "es": "Singapur",
            "en": "Singapore",
            "pt": "Singapura"
        }
    },
    {
        "id": 250,
        "name": "Sint Maarten (Dutch part)",
        "native": "Sint Maarten",
        "dial_code": "+1721",
        "iso2": "SX",
        "mask": "",
        "emoji": "🇸🇽",
        "translations": {
            "en": "Sint Maarten (Dutch part)",
            "pt": "Sint Maarten"
        }
    },
    {
        "id": 200,
        "name": "Slovakia",
        "native": "Slovensko",
        "dial_code": "+421",
        "iso2": "SK",
        "mask": "+421(###)###-###",
        "emoji": "🇸🇰",
        "translations": {
            "es": "República Eslovaca",
            "en": "Slovakia",
            "pt": "Eslováquia"
        }
    },
    {
        "id": 201,
        "name": "Slovenia",
        "native": "Slovenija",
        "dial_code": "+386",
        "iso2": "SI",
        "mask": "+386-##-###-###",
        "emoji": "🇸🇮",
        "translations": {
            "es": "Eslovenia",
            "en": "Slovenia",
            "pt": "Eslovênia"
        }
    },
    {
        "id": 202,
        "name": "Solomon Islands",
        "native": "Solomon Islands",
        "dial_code": "+677",
        "iso2": "SB",
        "mask": "+677-#####",
        "emoji": "🇸🇧",
        "translations": {
            "es": "Islas Salomón",
            "en": "Solomon Islands",
            "pt": "Ilhas Salomão"
        }
    },
    {
        "id": 203,
        "name": "Somalia",
        "native": "Soomaaliya",
        "dial_code": "+252",
        "iso2": "SO",
        "mask": "+252-#-###-###",
        "emoji": "🇸🇴",
        "translations": {
            "es": "Somalia",
            "en": "Somalia",
            "pt": "Somália"
        }
    },
    {
        "id": 204,
        "name": "South Africa",
        "native": "South Africa",
        "dial_code": "+27",
        "iso2": "ZA",
        "mask": "+27-##-###-####",
        "emoji": "🇿🇦",
        "translations": {
            "es": "República de Sudáfrica",
            "en": "South Africa",
            "pt": "República Sul-Africana"
        }
    },
    {
        "id": 205,
        "name": "South Georgia",
        "native": "South Georgia",
        "dial_code": "+500",
        "iso2": "GS",
        "emoji": "🇬🇸",
        "translations": {
            "es": "Islas Georgias del Sur y Sandwich del Sur",
            "en": "South Georgia",
            "pt": "Ilhas Geórgias do Sul e Sandwich do Sul"
        }
    },
    {
        "id": 116,
        "name": "South Korea",
        "native": "대한민국",
        "dial_code": "+82",
        "iso2": "KR",
        "mask": "+82-##-###-####",
        "emoji": "🇰🇷",
        "translations": {
            "es": "Corea del Sur",
            "en": "South Korea",
            "pt": "Coreia do Sul"
        }
    },
    {
        "id": 206,
        "name": "South Sudan",
        "native": "South Sudan",
        "dial_code": "+211",
        "iso2": "SS",
        "mask": "+211-##-###-####",
        "emoji": "🇸🇸",
        "translations": {
            "es": "Sudán del Sur",
            "en": "South Sudan",
            "pt": "Sudão do Sul"
        }
    },
    {
        "id": 207,
        "name": "Spain",
        "native": "España",
        "dial_code": "+34",
        "iso2": "ES",
        "mask": "+34(###)###-###",
        "emoji": "🇪🇸",
        "translations": {
            "es": "España",
            "en": "Spain",
            "pt": "Espanha"
        }
    },
    {
        "id": 208,
        "name": "Sri Lanka",
        "native": "śrī laṃkāva",
        "dial_code": "+94",
        "iso2": "LK",
        "mask": "+94-##-###-####",
        "emoji": "🇱🇰",
        "translations": {
            "es": "Sri Lanka",
            "en": "Sri Lanka",
            "pt": "Sri Lanka"
        }
    },
    {
        "id": 209,
        "name": "Sudan",
        "native": "السودان",
        "dial_code": "+249",
        "iso2": "SD",
        "mask": "+249-##-###-####",
        "emoji": "🇸🇩",
        "translations": {
            "es": "Sudán",
            "en": "Sudan",
            "pt": "Sudão"
        }
    },
    {
        "id": 210,
        "name": "Suriname",
        "native": "Suriname",
        "dial_code": "+597",
        "iso2": "SR",
        "mask": "+597-###-###",
        "emoji": "🇸🇷",
        "translations": {
            "es": "Surinam",
            "en": "Suriname",
            "pt": "Suriname"
        }
    },
    {
        "id": 211,
        "name": "Svalbard And Jan Mayen Islands",
        "native": "Svalbard og Jan Mayen",
        "dial_code": "+47",
        "iso2": "SJ",
        "emoji": "🇸🇯",
        "translations": {
            "es": "Islas Svalbard y Jan Mayen",
            "en": "Svalbard And Jan Mayen Islands",
            "pt": "Svalbard"
        }
    },
    {
        "id": 212,
        "name": "Swaziland",
        "native": "Swaziland",
        "dial_code": "+268",
        "iso2": "SZ",
        "mask": "+268-##-##-####",
        "emoji": "🇸🇿",
        "translations": {
            "es": "Suazilandia",
            "en": "Swaziland",
            "pt": "Suazilândia"
        }
    },
    {
        "id": 213,
        "name": "Sweden",
        "native": "Sverige",
        "dial_code": "+46",
        "iso2": "SE",
        "mask": "+46-##-###-####",
        "emoji": "🇸🇪",
        "translations": {
            "es": "Suecia",
            "en": "Sweden",
            "pt": "Suécia"
        }
    },
    {
        "id": 214,
        "name": "Switzerland",
        "native": "Schweiz",
        "dial_code": "+41",
        "iso2": "CH",
        "mask": "+41-##-###-####",
        "emoji": "🇨🇭",
        "translations": {
            "es": "Suiza",
            "en": "Switzerland",
            "pt": "Suíça"
        }
    },
    {
        "id": 215,
        "name": "Syria",
        "native": "سوريا",
        "dial_code": "+963",
        "iso2": "SY",
        "mask": "+963-##-####-###",
        "emoji": "🇸🇾",
        "translations": {
            "es": "Siria",
            "en": "Syria",
            "pt": "Síria"
        }
    },
    {
        "id": 216,
        "name": "Taiwan",
        "native": "臺灣",
        "dial_code": "+886",
        "iso2": "TW",
        "mask": "+886-####-####",
        "emoji": "🇹🇼",
        "translations": {
            "es": "Taiwán",
            "en": "Taiwan",
            "pt": "Taiwan"
        }
    },
    {
        "id": 217,
        "name": "Tajikistan",
        "native": "Тоҷикистон",
        "dial_code": "+992",
        "iso2": "TJ",
        "mask": "+992-##-###-####",
        "emoji": "🇹🇯",
        "translations": {
            "es": "Tayikistán",
            "en": "Tajikistan",
            "pt": "Tajiquistão"
        }
    },
    {
        "id": 218,
        "name": "Tanzania",
        "native": "Tanzania",
        "dial_code": "+255",
        "iso2": "TZ",
        "mask": "+255-##-###-####",
        "emoji": "🇹🇿",
        "translations": {
            "es": "Tanzania",
            "en": "Tanzania",
            "pt": "Tanzânia"
        }
    },
    {
        "id": 219,
        "name": "Thailand",
        "native": "ประเทศไทย",
        "dial_code": "+66",
        "iso2": "TH",
        "mask": "+66-##-###-###",
        "emoji": "🇹🇭",
        "translations": {
            "es": "Tailandia",
            "en": "Thailand",
            "pt": "Tailândia"
        }
    },
    {
        "id": 17,
        "name": "The Bahamas",
        "native": "Bahamas",
        "dial_code": "+1242",
        "iso2": "BS",
        "mask": "+1(242)###-####",
        "emoji": "🇧🇸",
        "translations": {
            "es": "Bahamas",
            "en": "The Bahamas",
            "pt": "Bahamas"
        }
    },
    {
        "id": 220,
        "name": "Togo",
        "native": "Togo",
        "dial_code": "+228",
        "iso2": "TG",
        "mask": "+228-##-###-###",
        "emoji": "🇹🇬",
        "translations": {
            "es": "Togo",
            "en": "Togo",
            "pt": "Togo"
        }
    },
    {
        "id": 221,
        "name": "Tokelau",
        "native": "Tokelau",
        "dial_code": "+690",
        "iso2": "TK",
        "mask": "+690-####",
        "emoji": "🇹🇰",
        "translations": {
            "es": "Islas Tokelau",
            "en": "Tokelau",
            "pt": "Tokelau"
        }
    },
    {
        "id": 222,
        "name": "Tonga",
        "native": "Tonga",
        "dial_code": "+676",
        "iso2": "TO",
        "mask": "+676-#####",
        "emoji": "🇹🇴",
        "translations": {
            "es": "Tonga",
            "en": "Tonga",
            "pt": "Tonga"
        }
    },
    {
        "id": 223,
        "name": "Trinidad And Tobago",
        "native": "Trinidad and Tobago",
        "dial_code": "+1868",
        "iso2": "TT",
        "mask": "+1(868)###-####",
        "emoji": "🇹🇹",
        "translations": {
            "es": "Trinidad y Tobago",
            "en": "Trinidad And Tobago",
            "pt": "Trinidad e Tobago"
        }
    },
    {
        "id": 224,
        "name": "Tunisia",
        "native": "تونس",
        "dial_code": "+216",
        "iso2": "TN",
        "mask": "+216-##-###-###",
        "emoji": "🇹🇳",
        "translations": {
            "es": "Túnez",
            "en": "Tunisia",
            "pt": "Tunísia"
        }
    },
    {
        "id": 225,
        "name": "Turkey",
        "native": "Türkiye",
        "dial_code": "+90",
        "iso2": "TR",
        "mask": "+90(###)###-####",
        "emoji": "🇹🇷",
        "translations": {
            "es": "Turquía",
            "en": "Turkey",
            "pt": "Turquia"
        }
    },
    {
        "id": 226,
        "name": "Turkmenistan",
        "native": "Türkmenistan",
        "dial_code": "+993",
        "iso2": "TM",
        "mask": "+993-#-###-####",
        "emoji": "🇹🇲",
        "translations": {
            "es": "Turkmenistán",
            "en": "Turkmenistan",
            "pt": "Turcomenistão"
        }
    },
    {
        "id": 227,
        "name": "Turks And Caicos Islands",
        "native": "Turks and Caicos Islands",
        "dial_code": "+1649",
        "iso2": "TC",
        "mask": "+1(649)###-####",
        "emoji": "🇹🇨",
        "translations": {
            "es": "Islas Turks y Caicos",
            "en": "Turks And Caicos Islands",
            "pt": "Ilhas Turcas e Caicos"
        }
    },
    {
        "id": 228,
        "name": "Tuvalu",
        "native": "Tuvalu",
        "dial_code": "+688",
        "iso2": "TV",
        "mask": "+688-2####",
        "emoji": "🇹🇻",
        "translations": {
            "es": "Tuvalu",
            "en": "Tuvalu",
            "pt": "Tuvalu"
        }
    },
    {
        "id": 229,
        "name": "Uganda",
        "native": "Uganda",
        "dial_code": "+256",
        "iso2": "UG",
        "mask": "+256(###)###-###",
        "emoji": "🇺🇬",
        "translations": {
            "es": "Uganda",
            "en": "Uganda",
            "pt": "Uganda"
        }
    },
    {
        "id": 230,
        "name": "Ukraine",
        "native": "Україна",
        "dial_code": "+380",
        "iso2": "UA",
        "mask": "+380(##)###-##-##",
        "emoji": "🇺🇦",
        "translations": {
            "es": "Ucrania",
            "en": "Ukraine",
            "pt": "Ucrânia"
        }
    },
    {
        "id": 231,
        "name": "United Arab Emirates",
        "native": "دولة الإمارات العربية المتحدة",
        "dial_code": "+971",
        "iso2": "AE",
        "mask": "+971-#-###-####",
        "emoji": "🇦🇪",
        "translations": {
            "es": "Emiratos Árabes Unidos",
            "en": "United Arab Emirates",
            "pt": "Emirados árabes Unidos"
        }
    },
    {
        "id": 232,
        "name": "United Kingdom",
        "native": "United Kingdom",
        "dial_code": "+44",
        "mask": "+44 ##### ### ###",
        "iso2": "GB",
        "emoji": "🇬🇧",
        "translations": {
            "es": "Reino Unido",
            "en": "United Kingdom",
            "pt": "Reino Unido"
        }
    },
    {
        "id": 233,
        "name": "United States",
        "native": "United States",
        "dial_code": "+1",
        "iso2": "US",
        "mask": "+1(###)###-####",
        "emoji": "🇺🇸",
        "translations": {
            "es": "Estados Unidos",
            "en": "United States",
            "pt": "Estados Unidos"
        }
    },
    {
        "id": 234,
        "name": "United States Minor Outlying Islands",
        "native": "United States Minor Outlying Islands",
        "dial_code": "+1",
        "iso2": "UM",
        "mask": "",
        "emoji": "🇺🇲",
        "translations": {
            "es": "Islas Ultramarinas Menores de Estados Unidos",
            "en": "United States Minor Outlying Islands",
            "pt": "Ilhas Menores Distantes dos Estados Unidos"
        }
    },
    {
        "id": 235,
        "name": "Uruguay",
        "native": "Uruguay",
        "dial_code": "+598",
        "iso2": "UY",
        "mask": "+598-#-###-##-##",
        "emoji": "🇺🇾",
        "translations": {
            "es": "Uruguay",
            "en": "Uruguay",
            "pt": "Uruguai"
        }
    },
    {
        "id": 236,
        "name": "Uzbekistan",
        "native": "O‘zbekiston",
        "dial_code": "+998",
        "iso2": "UZ",
        "mask": "+998-##-###-####",
        "emoji": "🇺🇿",
        "translations": {
            "es": "Uzbekistán",
            "en": "Uzbekistan",
            "pt": "Uzbequistão"
        }
    },
    {
        "id": 237,
        "name": "Vanuatu",
        "native": "Vanuatu",
        "dial_code": "+678",
        "iso2": "VU",
        "mask": "+678-#####",
        "emoji": "🇻🇺",
        "translations": {
            "es": "Vanuatu",
            "en": "Vanuatu",
            "pt": "Vanuatu"
        }
    },
    {
        "id": 238,
        "name": "Vatican City State (Holy See)",
        "native": "Vaticano",
        "dial_code": "+379",
        "iso2": "VA",
        "mask": "+39-6-698-#####",
        "emoji": "🇻🇦",
        "translations": {
            "es": "Santa Sede",
            "en": "Vatican City State (Holy See)",
            "pt": "Vaticano"
        }
    },
    {
        "id": 239,
        "name": "Venezuela",
        "native": "Venezuela",
        "dial_code": "+58",
        "iso2": "VE",
        "mask": "+58(###)###-####",
        "emoji": "🇻🇪",
        "translations": {
            "es": "Venezuela",
            "en": "Venezuela",
            "pt": "Venezuela"
        }
    },
    {
        "id": 240,
        "name": "Vietnam",
        "native": "Việt Nam",
        "dial_code": "+84",
        "iso2": "VN",
        "mask": "+84(###)####-###",
        "emoji": "🇻🇳",
        "translations": {
            "es": "Vietnam",
            "en": "Vietnam",
            "pt": "Vietnã"
        }
    },
    {
        "id": 241,
        "name": "Virgin Islands (British)",
        "native": "British Virgin Islands",
        "dial_code": "+1284",
        "iso2": "VG",
        "mask": "+1(284)###-####",
        "emoji": "🇻🇬",
        "translations": {
            "es": "Islas Vírgenes del Reino Unido",
            "en": "Virgin Islands (British)",
            "pt": "Ilhas Virgens Britânicas"
        }
    },
    {
        "id": 242,
        "name": "Virgin Islands (US)",
        "native": "United States Virgin Islands",
        "dial_code": "+1340",
        "iso2": "VI",
        "mask": "+1(340)###-####",
        "emoji": "🇻🇮",
        "translations": {
            "es": "Islas Vírgenes de los Estados Unidos",
            "en": "Virgin Islands (US)",
            "pt": "Ilhas Virgens Americanas"
        }
    },
    {
        "id": 243,
        "name": "Wallis And Futuna Islands",
        "native": "Wallis et Futuna",
        "dial_code": "+681",
        "iso2": "WF",
        "mask": "+681-##-####",
        "emoji": "🇼🇫",
        "translations": {
            "es": "Wallis y Futuna",
            "en": "Wallis And Futuna Islands",
            "pt": "Wallis e Futuna"
        }
    },
    {
        "id": 244,
        "name": "Western Sahara",
        "native": "الصحراء الغربية",
        "dial_code": "+212",
        "iso2": "EH",
        "mask": "",
        "emoji": "🇪🇭",
        "translations": {
            "es": "Sahara Occidental",
            "en": "Western Sahara",
            "pt": "Saara Ocidental"
        }
    },
    {
        "id": 245,
        "name": "Yemen",
        "native": "اليَمَن",
        "dial_code": "+967",
        "iso2": "YE",
        "mask": "+967-##-###-###",
        "emoji": "🇾🇪",
        "translations": {
            "es": "Yemen",
            "en": "Yemen",
            "pt": "Iêmen"
        }
    },
    {
        "id": 246,
        "name": "Zambia",
        "native": "Zambia",
        "dial_code": "+260",
        "iso2": "ZM",
        "mask": "+260-##-###-####",
        "emoji": "🇿🇲",
        "translations": {
            "es": "Zambia",
            "en": "Zambia",
            "pt": "Zâmbia"
        }
    },
    {
        "id": 247,
        "name": "Zimbabwe",
        "native": "Zimbabwe",
        "dial_code": "+263",
        "iso2": "ZW",
        "mask": "+263-#-######",
        "emoji": "🇿🇼",
        "translations": {
            "es": "Zimbabue",
            "en": "Zimbabwe",
            "pt": "Zimbabwe"
        }
    }
]